import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-2/5 flex-shrink-0">
            <div className="relative">
              <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-secondary-600 text-xs font-medium mb-6 whitespace-nowrap">
                Kakobuy Spreadsheet
              </span>
              <div className="rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20editorial%20product%20photography%20of%20a%20modern%20silver%20laptop%20displaying%20a%20colorful%20spreadsheet%20next%20to%20fashion%20items%20like%20a%20beige%20cap%20and%20white%20sneakers%20on%20a%20soft%20dusty%20rose%20textured%20desk%2C%20warm%20afternoon%20light%2C%20organized%20workspace%20aesthetic%2C%20premium%20tech%20lifestyle%2C%20high%20detail&width=800&height=1000&seq=kakobuy-about-img-v2&orientation=portrait"
                  alt="Kakobuy Spreadsheet interfejs"
                  className="w-full aspect-[4/5] object-cover object-top"
                />
              </div>
            </div>
          </div>
          <div className="lg:w-3/5">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-6">
              {t('about.title')}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              {t('about.content')}
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              {t('hero.cta_primary')}
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}